// src/services/gatoodleGuestsService.js
// Gäst:innen-Verwaltung für "El Gatoodle" gegen das Postgres-Schema
// "gatoodle" (Tabellen guests/termine/anmeldungen), das auch der
// Microservice nutzt — siehe el-gatoodle-referenz.md und die ADR zur
// Migration von Azure Table Storage. Ersetzt azureGatoodleGaesteService.js
// — der Browser spricht nicht mehr direkt mit Azure Table Storage, sondern
// mit der eigenen API unter /api/gatoodle/guests (Azure Functions,
// Entra-Auth gegen Postgres, kein Client-seitiges Secret mehr für diese Daten).
const BASE_URL = "/api/gatoodle/guests";

export const ANREDE_OPTIONS = ["Liebe", "Lieber", "Liebe:r"];

// Öffentliche Basis-Adresse der externen El-Gatoodle-Seite. Konfigurierbar per
// Env; Default ist ein Platzhalter, der final in US-GATO-006 gesetzt wird.
const GATOODLE_BASE_URL = (
  import.meta.env.VITE_GATOODLE_BASE_URL ||
  "https://www.malheur-fortuna.ch/el-gatoodle"
).replace(/\/+$/, "");

export const buildGatoodleUrl = (token) => `${GATOODLE_BASE_URL}/${token}`;

const withUrl = (guest) => ({ ...guest, url: buildGatoodleUrl(guest.token) });

async function parseErrorMessage(response, fallback) {
  try {
    const data = await response.json();
    return data?.error || fallback;
  } catch {
    return fallback;
  }
}

// Alle Gäst:innen laden, inkl. ihrer registrierten Termine (Abgleich).
export const getAllGaeste = async () => {
  const response = await fetch(BASE_URL);
  if (!response.ok) {
    throw new Error("Die Gäst:innen konnten nicht geladen werden.");
  }
  const guests = await response.json();
  return guests.map(withUrl);
};

// Neue Gäst:in anlegen (Token wird serverseitig erzeugt).
export const createGast = async (gastData, erstelltVon = "") => {
  const response = await fetch(BASE_URL, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      anrede: gastData.anrede || ANREDE_OPTIONS[0],
      vorname: gastData.vorname,
      nachname: gastData.nachname,
      email: gastData.email || "",
      erstelltVon,
    }),
  });
  if (!response.ok) {
    throw new Error(await parseErrorMessage(response, "Die Gäst:in konnte nicht gespeichert werden."));
  }
  return withUrl(await response.json());
};

// Stammdaten aktualisieren (kein_termin_passt/link_geoeffnet_am bleiben
// unberührt, da sie extern vom Microservice geschrieben werden).
export const updateGast = async (id, gastData) => {
  const response = await fetch(`${BASE_URL}/${id}`, {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      anrede: gastData.anrede || ANREDE_OPTIONS[0],
      vorname: gastData.vorname,
      nachname: gastData.nachname,
      email: gastData.email || "",
    }),
  });
  if (!response.ok) {
    throw new Error(await parseErrorMessage(response, "Die Gäst:in konnte nicht aktualisiert werden."));
  }
  return withUrl(await response.json());
};

// Gäst:in löschen (Anmeldungen kaskadieren serverseitig).
export const deleteGast = async (id) => {
  const response = await fetch(`${BASE_URL}/${id}`, { method: "DELETE" });
  if (!response.ok && response.status !== 404) {
    throw new Error("Die Gäst:in konnte nicht gelöscht werden.");
  }
  return true;
};
